const withSlash = (url, fallback) => {
  const value = (url || fallback || '').trim()
  return value.endsWith('/') ? value : `${value}/`
}

export const domain = withSlash(process.env.VUE_APP_API_DOMAIN, 'https://lk.rus-bit.ru/')
const ratingBase = (process.env.VUE_APP_RATING_API_URL || 'https://poools.top/api').replace(/\/?$/, '')

export const config = {
  updateTimeSec: 60 * 5,
  updateTimeWalletBalance: 1000 * 60 * 10,
  watcherURL: process.env.VUE_APP_WATCHER_URL || 'https://wl.poools.top',
  api: {
    auth: {
      login: domain + 'api/v1/auth/login',
      logout: domain + 'api/v1/auth/logout',
      refresh: domain + 'api/v1/auth/refresh'
    },
    registration: domain + 'api/v1/reg',
    verifyEmail: domain + 'api/v1/reg/verify',
    validate: {
      email: domain + 'api/v1/reg/valid/email',
      account: domain + 'api/v1/reg/valid/account'
    },
    user: {
      users: domain + 'api/v1/users',
      current: domain + 'api/v1/users/current',
      stratumInfo: domain + 'api/v1/users/stratum',
      update: domain + 'api/v1/users/update',
      dayHashrate: domain + 'api/v1/users/hashrate',
      refreshStat: domain + 'api/v1/users/refreshStat',
      refreshStat10: domain + 'api/v1/users/refreshStat10',
      resetPassword: domain + 'api/v1/users/resetPassword',
      changePassword: domain + 'api/v1/users/changePassword',
      watchers: domain + 'api/v1/users/watchers',
      deleteWatcher: domain + 'api/v1/users/deletewatcher',
      addWatcher: domain + 'api/v1/users/addwatcher',
      add: domain + 'api/v1/users/add'
    },
    pool: {
      all: domain + 'api/v1/pool/all',
      pool: domain + 'api/v1/pool',
      refreshStat: domain + 'api/v1/pool/refreshStat',
      refreshStat10: domain + 'api/v1/pool/refreshStat10',
      update: domain + 'api/v1/pool/edit',
      wallet: domain + 'api/v1/pool/wallet',
      connectToPool: domain + 'api/v1/pool/connectToPool',
      connectUserToPool: domain + 'api/v1/pool/connectUserToPool'
    },
    miner: {
      id: domain + 'api/v1/miners',
      stat: domain + 'api/v1/miners/stat',
      user: domain + 'api/v1/miners',
      all: domain + 'api/v1/miners/all',
      nominal: domain + 'api/v1/miners/nominal',
      delete: domain + 'api/v1/miners/delete',
      calcallhashrates: domain + 'api/v1/miners/calcallhashrates',
      calcallincomes: domain + 'api/v1/miners/calcallincomes',
      allProxyConnections: domain + 'api/v1/miners/connections',
      newPool: domain + 'api/v1/miners/newPool',
      flushCache: domain + 'api/v1/miners/flushCache',
      terminateAll: domain + 'api/v1/miners/terminateAll'
    },
    difficulty: domain + 'api/v1/difficulty',
    excel: {
      download: domain + 'api/v1/download/income'
    },
    statistic: {
      user: domain + 'api/v1/stat/user',
      miner: domain + 'api/v1/stat/miner'
    },
    dashboard: {
      user: domain + 'api/v1/dashboard',
      stat: domain + 'api/v1/dashboard/chart',
      miners: domain + 'api/v1/dashboard/miners',
      incomes: domain + 'api/v1/dashboard/income',
      admin: domain + 'api/v1/dashboard/admin',
      imexTksCurrencyBalance: domain + 'api/v1/dashboard/admin/imex-tks-currency-balance'
    },
    wallet: {
      user: domain + 'api/v1/wallet',
      network: domain + 'api/v1/wallet/network',
      withdraw: domain + 'api/v1/wallet/withdraw',
      withdrawConfirm: domain + 'api/v1/wallet/withdraw/confirm',
      pair: domain + 'api/v1/wallet/pair',
      convert: domain + 'api/v1/wallet/convert',
      deposit: domain + 'api/v1/wallet/deposit',
      transactions: domain + 'api/v1/wallet/transactions'
    },
    balance: {
      user: domain + 'api/v1/balance'
    },
    rank: {
      top: `${ratingBase}/rank/pools/top/by-period?unit=th&period=`,
      watchers: `${ratingBase}/rank/api/watcher/`,
      telegramUsers: `${ratingBase}/rank/api/telegram/`,
      badLinks: `${ratingBase}/rank/api/badlink/`
    },
    finance: {
      day: domain + 'api/v1/finance',
      poolBalance: domain + 'api/v1/finance/balance',
      expect: domain + 'api/v1/finance/expect',
      paid: domain + 'api/v1/finance/paid',
      payoutBonus: domain + 'api/v1/finance/payoutBonus',
      payout: domain + 'api/v1/finance/payout',
      recalc: domain + 'api/v1/finance/recalc',
      payallincome: domain + 'api/v1/finance/payallincome',
      payallbonus: domain + 'api/v1/finance/payallbonus',
      payallagent: domain + 'api/v1/finance/payallagent',
      month: domain + 'api/v1/finance/month',
      allpayouts: domain + 'api/v1/finance/allpayouts',
      transfer: domain + 'api/v1/finance/transfer',
      totalWithdrawal: domain + 'api/v1/finance/withdrawal/total',
      statWithdrawal: domain + 'api/v1/finance/withdrawal/stat',
      totalExchange: domain + 'api/v1/finance/exchange/total',
      statExchange: domain + 'api/v1/finance/exchange/stat',
      totalDeposit: domain + 'api/v1/finance/deposit/total',
      exchangeFee: domain + 'api/v1/finance/exchange/fee',
      exchangeFeeTotal: domain + 'api/v1/finance/exchange/fee/total'
    },
    email: {
      send: domain + 'api/v1/email/send'
    },
    subuser: {
      miners: domain + 'api/v1/subuser/miners',
      add: domain + 'api/v1/subuser/add',
      subusers: domain + 'api/v1/subuser',
      delete: domain + 'api/v1/subuser/delete',
      edit: domain + 'api/v1/subuser/edit',
      incomes: domain + 'api/v1/subuser/income',
      pay: domain + 'api/v1/subuser/pay'
    },
    settings: {
      all: domain + 'api/v1/settings',
      wallet: domain + 'api/v1/settings/wallet',
      addWallet: domain + 'api/v1/settings/wallet/add',
      main: domain + 'api/v1/settings/main',
      code: domain + 'api/v1/settings/verify',
      security: domain + 'api/v1/settings/security',
      changePassword: domain + 'api/v1/settings/changePassword',
      notification: domain + 'api/v1/settings/notification'
    },
    agent: {
      current: domain + 'api/v1/agent',
      all: domain + 'api/v1/agent/all',
      create: domain + 'api/v1/agent/create',
      rank: domain + 'api/v1/agent/rank',
      update: domain + 'api/v1/agent/update',
      addReferral: domain + 'api/v1/referral/add',
      referral: domain + 'api/v1/referral/all',
      referrals: domain + 'api/v1/referral',
      admin: domain + 'api/v1/agent/createMain'
    },
    poolIncome: {
      pools: domain + 'api/v1/poolincome/pool',
      owners: domain + 'api/v1/poolincome/owner',
      accounts: domain + 'api/v1/poolincome/account',
      income: domain + 'api/v1/poolincome/income'
    },
    rubWithdrawal: {
      all: domain + 'api/v1/wallet/withdraw/rub-bank/admin/all',
      pending: domain + 'api/v1/wallet/withdraw/rub-bank/admin/pending',
      status: domain + 'api/v1/wallet/withdraw/rub-bank/admin/{id}/status'
    },
    treasury: {
      all: domain + 'api/v1/admin/treasury',
      status: domain + 'api/v1/admin/treasury/{id}/status',
      exportCsv: domain + 'api/v1/admin/treasury/export.csv'
    },
    adminWallet: {
      byUser: domain + 'api/v1/admin/wallets/user/{userId}',
      fnsCertified: domain + 'api/v1/admin/wallets/{walletId}/fns-certified'
    },
    corporateWallet: {
      all: domain + 'api/v1/admin/corporate-wallets',
      byId: domain + 'api/v1/admin/corporate-wallets/{id}',
      fnsCertified: domain + 'api/v1/admin/corporate-wallets/{id}/fns-certified'
    }
  }
}
